// Low-resource device gate (07-19 mobile crash fix).
//
// iOS Safari kills the tab with "A problem repeatedly occurred" when a page
// outgrows WebKit's per-tab memory budget — on /explore the stack of LiveKit
// rail videos + the live explorer iframe + full-res card art + the full-page
// invert filter blew straight through it on an iPhone 13 mini (repro'd in
// light mode too, so no single feature is the whole story; it's the sum).
//
// Detection is a heuristic because iOS never exposes navigator.deviceMemory
// (Chromium-only). Where deviceMemory exists we trust it; everywhere else a
// touch-first device with a phone-sized screen counts as low-resource. The
// 480px min-dimension keeps iPads and Android tablets out of the gate.
//
// Computed once at module load — device class can't change mid-session.
const isLowResourceDevice = (() => {
  try {
    if (typeof navigator !== 'undefined' && navigator.deviceMemory) {
      return navigator.deviceMemory <= 4;
    }
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    const touchOnly = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    const phoneSized = Math.min(
      window.screen?.width || Infinity,
      window.screen?.height || Infinity
    ) <= 480;
    return touchOnly && phoneSized;
  } catch (e) {
    return false;
  }
})();

export default isLowResourceDevice;
